/*
 * fn: isDefined
 *
 * Determines if an input is undefined
 *
 */
export const isDefined = <T>(value: T | undefined): value is T => value !== undefined
